import { IApiSuccessWrapper, IState } from '$/types'
import { apiSlice } from '.'

export interface IGetSystemScopeStatesParams {
  operatorCodes?: string[]
  regionCodes?: string[]
}

export const systemScopeStatesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getStates: build.query<IState[], IGetSystemScopeStatesParams>({
      query: ({ operatorCodes, regionCodes }) => ({
        method: 'GET',
        url: '/states',
        params: {
          // Only include parameters in query string if provided
          ...(operatorCodes != null &&
            operatorCodes.length > 0 && { operatorCode: operatorCodes }),
          ...(regionCodes != null &&
            regionCodes.length > 0 && { regionCode: regionCodes })
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IState[]
      }
    })
  })
})

export const { useGetStatesQuery } = systemScopeStatesApi
